import { capitalize } from 'lodash';

export function buildCustomStage(stage) {
  const { key, label, defaultCloseProbability } = stage;
  const customStage = { key };

  // by default, a stage label is the capitalized version of the key
  if (label && label !== capitalize(key)) {
    customStage.label = label;
  }

  if (defaultCloseProbability || defaultCloseProbability === 0) {
    customStage.defaultCloseProbability = defaultCloseProbability;
  }

  return Object.keys(customStage).length > 1 ? customStage : null;
}
